export const NORMAL = 'normal'
export const UN_START = 'not_start'
export const ENDED = 'ended'

export const STATUS_OPTION = [
    {label: '进行中', value: NORMAL},
    {label: '未开始', value: UN_START},
    {label: '已结束', value: ENDED},
]


export const STATUS_DESC = (status) => {
    return STATUS_OPTION.find(item => item.value === status).label
}
